import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';

import { Checkbox } from '@monoimin/atoms';

import type { SelectFilterVariants } from '../types';

export const SelectOption = ({
  selected,
  variant = 'column',
  children,
}: PropsWithChildren<{
  selected: boolean;
  variant?: SelectFilterVariants;
}>) => {
  const optionClasses =
    variant === 'column'
      ? 'select__option_variant_column'
      : 'select__option_variant_row';

  const optionSelectedClasses =
    variant === 'column'
      ? 'select__option_variant_column_active'
      : 'select__option_variant_row_active';

  return (
    <div className={clsx(optionClasses, selected && optionSelectedClasses)}>
      {variant === 'column' && (
        <Checkbox checked={selected} readOnly className='pointer-events-none' />
      )}
      <span className='whitespace-nowrap'>{children}</span>
    </div>
  );
};
